export const ACTIONABLE_TEMPLATE_TYPES = ['quick_replies', 'deflection', 'mll'];
